// extracted by css-extract-rspack-plugin
export default {"right":"z1STp","ad":"bzFyY","right_wrapper":"qbU3x","rightWrapper":"qbU3x"};